import React from 'react';
import * as PropTypes from 'prop-types';

import { DropdownWithDots, Tooltip } from '../../popovers';
import { TalentDropdownComp } from '../talent-dropdown';

import {
  TextInfo,
  TalentWrapper,
} from './styled-components';

const Talent = ({
  _id,
  url,
  stack,
  requestId,
  enFullName,
  profDirection,
  handleTalentDelete,
  withoutAdditionalActions,
}) => (
  <TalentWrapper
    withoutAdditionalActions={withoutAdditionalActions}
  >
    <Tooltip title="Full Name">
      <TextInfo >
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={url} target="_blank">
          {enFullName}
        </a>
      </TextInfo>
    </Tooltip>

    <Tooltip title="ProfDirection">
      <TextInfo >{profDirection || ' - - - '}</TextInfo>
    </Tooltip>

    <Tooltip title="Stack">
      <TextInfo >{stack || ' - - - '}</TextInfo>
    </Tooltip>

    {!withoutAdditionalActions &&
      <DropdownWithDots
        overlay={TalentDropdownComp({
          _id,
          requestId,
          handleTalentDelete,
        })}
      />}
  </TalentWrapper>
);

Talent.propTypes = {
  _id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  stack: PropTypes.string,
  profDirection: PropTypes.string,
  enFullName: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
  handleTalentDelete: PropTypes.func.isRequired,
  withoutAdditionalActions: PropTypes.bool,
};

Talent.defaultProps = {
  stack: '',
  profDirection: '',
  withoutAdditionalActions: false,
};

export default Talent;



// WEBPACK FOOTER //
// ./src/components/talents-list/talent/index.js